import React from "react";
import { IoCloseOutline, IoHeadsetOutline } from "react-icons/io5";
import { MdOutlineDashboard, MdOutlinePendingActions } from "react-icons/md";
import { HiOutlineUsers } from "react-icons/hi2";
import { RiBuildingLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../../assests/images/weblogo.png";

// ─── Component ────────────────────────────────────────────────────────────────
const SideBar = ({ setShowSiderbar }) => {
  const { t } = useTranslation();

  // ─── Nav config (now translated) ─────────────────────────────────────────
  const navSections = [
    {
      label: t("AdminSidebar.Navigation", "NAVIGATION"),
      items: [
        {
          reactIcon: <MdOutlineDashboard size={18} />,
          title: t("AdminSidebar.Dashboard"),
          url: "/admin/dashboard",
        },
        {
          reactIcon: <HiOutlineUsers size={18} />,
          title: t("AdminSidebar.User"),
          url: "managment",
        },
        {
          reactIcon: <RiBuildingLine size={18} />,
          title: t("AdminSidebar.AgencyManagement"),
          url: "agencymanagement",
        },
        {
          reactIcon: <MdOutlinePendingActions size={18} />,
          title: t("AdminSidebar.PendingTransactions"),
          url: "transaction",
        },
      ],
    },
    {
      label: t("AdminSidebar.QuickAccess", "QUICK ACCESS"),
      items: [
        {
          reactIcon: <IoHeadsetOutline size={18} />,
          title: t("AdminSidebar.SupportTicket"),
          url: "support",
        },
      ],
    },
  ];

  return (
    <div className="
      flex flex-col h-full w-64
      bg-[#0e1525] dark:bg-[#020617]
      border-r border-white/5
      overflow-y-auto py-10
      shadow-[10px_0_40px_rgba(0,0,0,.75)]
      rounded-tr-[30px] rounded-br-[30px]
    ">

      {/* ── Logo ── */}
      <div className="pt-6 pb-2 px-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src={logo} alt="Ellipticline Logo" className="h-11 w-auto object-contain" />
        </div>
        <button
          className="xl:hidden text-white/80 hover:text-white transition-colors"
          onClick={() => setShowSiderbar?.(false)}
        >
          <IoCloseOutline size={22} />
        </button>
      </div>

      {/* ── Sections ── */}
      <nav className="flex-1 px-3 mt-4 space-y-7 pb-4">
        {navSections.map((section) => (
          <div key={section.label}>

            {/* Section label */}
            <p className="px-3 mb-2 text-[10px] font-semibold tracking-[0.15em] text-white/80 uppercase">
              {section.label}
            </p>

            {/* Items */}
            <ul className="space-y-3">
              {section.items.map((item) => (
                <li key={item.url}>
                  <NavLink
                    to={item.url}
                    end={item.url === "/admin/dashboard"}
                    className={({ isActive }) =>
                      `group relative flex items-center gap-3 px-3 py-[10px] rounded-xl
                       cursor-pointer select-none transition-all duration-200
                       ${isActive ? "border-[1px] border-[#01d28c]" : "border-0"}`
                    }
                    style={({ isActive }) => ({
                      background: isActive
                        ? "radial-gradient(circle at 0 0,rgba(24,226,143,.25),transparent 55%),rgba(15,23,42,.98)"
                        : "#0b1629",
                    })}
                  >
                    {({ isActive }) => (
                      <>
                        {/* Active dot */}
                        {isActive && (
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-green-400" />
                        )}

                        {/* Icon box */}
                        <span className={`
                          flex-shrink-0 flex items-center justify-center
                          w-9 h-9 rounded-xl transition-all duration-200
                          ${isActive ? "bg-[#0c1129]" : "bg-[#1a2540] group-hover:bg-[#1e2d47]"}
                        `}>
                          <span className={isActive ? "text-[#01d28c]" : "text-white/70 group-hover:text-white/90"}>
                            {item.reactIcon}
                          </span>
                        </span>

                        {/* Title */}
                        <div className="flex flex-col min-w-0">
                          <span className={`
                            text-[14px] font-medium leading-tight
                            ${isActive ? "text-white" : "text-white/70 group-hover:text-white/90"}
                          `}>
                            {item.title}
                          </span>
                        </div>
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </div>
  );
};

export default SideBar;